import { ENV } from '@/shared/config';
import type { StateCreator } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

// 개발 환경에서만 devtools 활성화
const isDevelopment = ENV.IS_DEVELOPMENT;

const DEVTOOLS_CONNECTION_NAME = 'MyApp';

export type StoreCreator<T> = StateCreator<T, [], []>;

export type StoreImmerCreator<T> = StateCreator<
  T,
  [['zustand/immer', never]],
  []
>;

type StoreInitializer<T> = StateCreator<
  T,
  [],
  [['zustand/devtools', never], ['zustand/subscribeWithSelector', never]]
>;

type StoreInitializerWithImmer<T> = StateCreator<
  T,
  [],
  [
    ['zustand/devtools', never],
    ['zustand/subscribeWithSelector', never],
    ['zustand/immer', never],
  ]
>;

// 공통 미들웨어 적용 헬퍼
export const createStoreWithMiddleware = <T>(
  stateCreator: StateCreator<T, [], []>,
  storeName: string,
): StoreInitializer<T> => {
  if (isDevelopment) {
    return devtools(subscribeWithSelector(stateCreator), {
      name: DEVTOOLS_CONNECTION_NAME,
      store: storeName,
    }) as StoreInitializer<T>;
  }

  return subscribeWithSelector(stateCreator) as StoreInitializer<T>;
};

// immer 미들웨어 포함 헬퍼
export const createStoreWithImmerMiddleware = <T>(
  stateCreator: StateCreator<T, [['zustand/immer', never]], []>,
  storeName: string,
): StoreInitializerWithImmer<T> => {
  if (isDevelopment) {
    return devtools(subscribeWithSelector(immer(stateCreator)), {
      name: DEVTOOLS_CONNECTION_NAME,
      store: storeName,
    }) as StoreInitializerWithImmer<T>;
  }

  return subscribeWithSelector(
    immer(stateCreator),
  ) as StoreInitializerWithImmer<T>;
};
